import { breakingNews, siteName } from "@/mocks/chigua";

export default function BreakingTicker() {
  const loop = [...breakingNews, ...breakingNews];
  return (
    <section aria-label="实时快讯" className="bg-primary-500 text-background-50">
      <div className="mx-auto flex max-w-7xl items-center gap-3 overflow-hidden px-4 py-2.5 md:px-6">
        <div className="flex shrink-0 items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
          </span>
          <span className="label font-label text-xs font-bold tracking-widest md:text-sm">
            {siteName}快讯
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee gap-12 whitespace-nowrap">
            {loop.map((item, idx) => (
              <span
                key={idx}
                className="inline-flex items-center gap-3 text-xs font-medium md:text-sm"
              >
                <i className="ri-flashlight-fill text-accent-200"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium sm:inline-flex">
          <i className="ri-time-line"></i> 实时
        </span>
      </div>
    </section>
  );
}